var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.show)?_c('div',{class:[_vm.archive && !_setup.isActive && 'archive', 'csr-wish-btn'],on:{"click":_setup.clickWishBtn}},[_c('i',{class:['csr-wish-btn__icon', _setup.isActive && 'active']}),_c('span',{staticClass:"csr-wish-btn__txt"},[_vm._v("心愿单")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }